import { render, staticRenderFns } from "./FareAllocation.vue?vue&type=template&id=4cefc554&scoped=true&"
import script from "./FareAllocation.vue?vue&type=script&lang=js&"
export * from "./FareAllocation.vue?vue&type=script&lang=js&"
import style0 from "./FareAllocation.vue?vue&type=style&index=0&id=4cefc554&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cefc554",
  null
  
)

export default component.exports